<template>

  <section class=" main-container" v-if="banners">
    <BigTitle class="mb-2 mb-sm-4" title="آنجل در یک نگاه" />

    <div class="banner-category banner-category-des">
      <figure class="w-100" v-if="banners.first_bannerDes">
        <a v-if="banners.first_bannerDes.link" class="w-100 d-inline-block" :href="banners.first_bannerDes.link">
          <img class="w-100 h-auto" height="122" width="306" loading="lazy" decoding="async"
            :src="banners.first_bannerDes.picture" :alt="banners.first_bannerDes.title" />
        </a>
        <router-link v-else class="w-100 d-inline-block" :to="findUrl(
          banners.first_bannerDes.linkable_type,
          banners.first_bannerDes.linkable_id,
          banners.first_bannerDes.slug
        )
          ">
          <img class="w-100 h-auto" height="122" width="306" decoding="async" :src="banners.first_bannerDes.picture"
            :alt="banners.first_bannerDes.title" />
        </router-link>
      </figure>
      <figure class="w-100" v-if="banners.second_bannerDes">
        <a v-if="banners.second_bannerDes.link" class="w-100 d-inline-block" :href="banners.second_bannerDes.link">
          <img loading="lazy" class="w-100 h-auto" height="122" width="306" decoding="async"
            :src="banners.second_bannerDes.picture" :alt="banners.second_bannerDes.title" />
        </a>
        <router-link v-else class="w-100 d-inline-block" :to="findUrl(
          banners.second_bannerDes.linkable_type,
          banners.second_bannerDes.linkable_id,
          banners.second_bannerDes.slug
        )
          ">
          <img loading="lazy" class="w-100 h-auto" height="122" width="306" decoding="async"
            :src="banners.second_bannerDes.picture" :alt="banners.second_bannerDes.title" />
        </router-link>
      </figure>
      <figure class="w-100" v-if="banners.third_bannerDes">
        <a v-if="banners.third_bannerDes.link" class="w-100 d-inline-block" :href="banners.third_bannerDes.link">
          <img loading="lazy" class="w-100 h-auto" height="122" width="306" decoding="async"
            :src="banners.third_bannerDes.picture" :alt="banners.third_bannerDes.title" />
        </a>
        <router-link v-else class="w-100 d-inline-block" :to="findUrl(
          banners.third_bannerDes.linkable_type,
          banners.third_bannerDes.linkable_id,
          banners.third_bannerDes.slug
        )
          ">
          <img loading="lazy" class="w-100 h-auto" height="122" width="306" decoding="async"
            :src="banners.third_bannerDes.picture" :alt="banners.third_bannerDes.title" />
        </router-link>
      </figure>
      <figure class="w-100" v-if="banners.fourth_bannerDes">
        <a v-if="banners.fourth_bannerDes.link" class="w-100 d-inline-block" :href="banners.first_bannerDes.link">
          <img loading="lazy" class="w-100 h-auto" height="122" width="306" decoding="async"
            :src="banners.fourth_bannerDes.picture" :alt="banners.fourth_bannerDes.title" />
        </a>
        <router-link v-else class="w-100 d-inline-block" :to="findUrl(
          banners.fourth_bannerDes.linkable_type,
          banners.fourth_bannerDes.linkable_id,
          banners.fourth_bannerDes.slug
        )
          ">
          <img loading="lazy" class="w-100 h-auto" height="122" width="306" decoding="async"
            :src="banners.fourth_bannerDes.picture" :alt="banners.fourth_bannerDes.title" />
        </router-link>
      </figure>
    </div>
    <div class="  banner-category banner-category-mobile">
      <figure class="w-100" v-if="banners.first_bannerMobile">
        <a v-if="banners.first_bannerMobile.link" class="w-100 d-inline-block" :href="banners.first_bannerMobile.link">
          <img loading="lazy" class="w-100 h-auto" height="122" width="306" decoding="async"
            :src="banners.first_bannerMobile.picture" :alt="banners.first_bannerMobile.title" />
        </a>
        <router-link v-else class="w-100 d-inline-block" :to="findUrl(
          banners.first_bannerMobile.linkable_type,
          banners.first_bannerMobile.linkable_id,
          banners.first_bannerMobile.slug
        )
          ">
          <img loading="lazy" class="w-100 h-auto" height="122" width="306" decoding="async"
            :src="banners.first_bannerMobile.picture" :alt="banners.first_bannerMobile.title" />
        </router-link>
      </figure>
      <figure class="w-100" v-if="banners.second_bannerMobile">
        <a v-if="banners.second_bannerMobile.link" class="w-100 d-inline-block"
          :href="banners.second_bannerMobile.link">
          <img loading="lazy" class="w-100 h-auto" height="122" width="306" decoding="async"
            :src="banners.second_bannerMobile.picture" :alt="banners.second_bannerMobile.title" />
        </a>
        <router-link v-else class="w-100 d-inline-block" :to="findUrl(
          banners.second_bannerMobile.linkable_type,
          banners.second_bannerMobile.linkable_id,
          banners.second_bannerMobile.slug
        )
          ">
          <img loading="lazy" class="w-100 h-auto" height="122" width="306" decoding="async"
            :src="banners.second_bannerMobile.picture" :alt="banners.second_bannerMobile.title" />
        </router-link>
      </figure>
      <figure class="w-100" v-if="banners.third_bannerMobile">
        <a v-if="banners.third_bannerMobile.link" class="w-100 d-inline-block" :href="banners.third_bannerMobile.link">
          <img loading="lazy" class="w-100 h-auto" height="122" width="306" decoding="async"
            :src="banners.third_bannerMobile.picture" :alt="banners.third_bannerMobile.title" />
        </a>
        <router-link v-else class="w-100 d-inline-block" :to="findUrl(
          banners.third_bannerMobile.linkable_type,
          banners.third_bannerMobile.linkable_id,
          banners.third_bannerMobile.slug
        )
          ">
          <img loading="lazy" class="w-100 h-auto" height="122" width="306" decoding="async"
            :src="banners.third_bannerMobile.picture" :alt="banners.third_bannerMobile.title" />
        </router-link>
      </figure>
      <figure class="w-100" v-if="banners.fourth_bannerMobile">
        <a v-if="banners.fourth_bannerMobile.link" class="w-100 d-inline-block" :href="banners.first_bannerMobile.link">
          <img loading="lazy" class="w-100 h-auto" height="122" width="306" decoding="async"
            :src="banners.fourth_bannerMobile.picture" :alt="banners.fourth_bannerMobile.title" />
        </a>
        <router-link v-else class="w-100 d-inline-block" :to="findUrl(
          banners.fourth_bannerMobile.linkable_type,
          banners.fourth_bannerMobile.linkable_id,
          banners.fourth_bannerMobile.slug
        )
          ">
          <img class="w-100 h-auto" height="122" width="306" loading="lazy" decoding="async"
            :src="banners.fourth_bannerMobile.picture" :alt="banners.fourth_bannerMobile.title" />
        </router-link>
      </figure>
    </div>


  </section>
</template>
<script>
import findUrl from "@/libraries/links/LinkResolver";
import BigTitle from "@/parts/Front/nicecomponents/shared/BigTitle";

export default {
  components: {
    BigTitle
  },
  computed: {
    banners() {
      if (this.$store.getters["front/getHomeData"] != null) {
        let advertise = this.$store.getters["front/getHomeData"].advertise;
        return advertise;
      } else {
        return null;
      }
    },
  },
  methods: {
    findUrl,
  },
};
</script>
<style scoped>
.main-container {
  margin-top: 70px;
}

.banner-category {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
  margin-top: 32px;
  padding-top: 1.5rem;

}

.banner-category.banner-category-mobile {
  display: none;
}

.banner-category figure {
  border-radius: 16px;
  overflow: hidden;
  display: flex;
  margin: 0;
}

@media screen and (max-width:1000px) {
  .banner-category {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;

  }

  .banner-category.banner-category-des {
    display: none;
  }

  .banner-category.banner-category-mobile {
    display: grid;
  }
}

@media screen and (max-width:600px) {
  .main-container {
    margin-top: 50px;
  }

  .banner-category figure {
    border-radius: 12px;
    gap: 10px;


  }

  .banner-category {

    margin-top: 10px;

  }
}
</style>
